import React, { useContext } from "react";
import _ from "lodash";
import { useMediaQuery } from "react-responsive";
import { baseUrl } from "../../../../../config/config";
import WidgetContext from "../../../../../contexts/WidgetContext";
import GetCurrency from "../../../../../helpers/services";
import { fontColorFunction, formatCurrencyAmount } from "../../../../../helpers/common";
import TippyIcon from "../../../../../components/TippyIcon";
import { CurrencyWithAmount } from "../../../../../helpers/utils";
import { RESTRICTED_EVENT_ID } from "../../../config/constants";
import PaymentButton from "./PaymentButton";

const CartButtons = ({
	onProceed,
	setIsCheckoutSubmitted,
	eventDetails,
	curComp,
	selectedTickets,
	query,
	freeRegistration,
	waitlistRegistration,
	setApiLoading,
	utm,
	isWidget,
	couponCode,
	orderAmount,
	orderAmountPreview,
	isWaitlist,
	attendeesDetails,
	reviewDetails,
	btnDisabled,
	toggleTicketSummary,
	discount,
	emailApiErrors,
	waitlistDetails,
	textInputErrors,
	isValidating
}) => {
	const {
		isCheckoutLoading,
		isApproval,
		isInternationalEvent,
		paymentMethod,
		isWaitlist: isWaitlistPayment,
	} = useContext(WidgetContext);

	const handleMediaQueryChange = (matches) => {
		smallerScreen = matches;
	};

	const restrictedEventId = eventDetails?.event_id === RESTRICTED_EVENT_ID.ID

	const currency = selectedTickets.find(obj => obj.currency_name !== eventDetails.currency_name)
		? selectedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
			.currency_name
		: eventDetails.currency_name;

	let smallerScreen = useMediaQuery(
		{ maxWidth: 768 },
		undefined,
		handleMediaQueryChange,
	);
	//for anchor tag
	const stripHtmlTags = htmlString => {
		let result = htmlString.replace(/<\/?[^>]+(>|$)/g, (tag) => {
			return tag.startsWith("<a ") || tag === "</a>" ? tag : "";
		});

		result = result.replace(/<a\s+([^>]*href=["'][^"']+["'][^>]*)>/g, (match, p1) => {
			return `<a ${p1} target="_blank" style="color:blue;">`;
		});

		return result;
	};

	const registerButtonType = (totalAmount) => {
		if (isApproval) {
			return (
				<button
					className="btn cart-btn px-3 d-block btn-height no-box-shadow w-100 mx-auto my-3 mt-md-0"
					onClick={waitlistRegistration}
					disabled={btnDisabled}
					id={query?.registerYourInterestId ? query?.registerYourInterestId : "register-your-interest-button"}
				>
					Register Your Interest
				</button>
			);
		} else if (isWaitlist && !isWaitlistPayment) {
			return (
				<button
					className="btn cart-btn px-3 d-block btn-height no-box-shadow w-100 mx-auto my-3 mt-md-0"
					onClick={waitlistRegistration}
					disabled={btnDisabled}
					id={query?.joinWaitlistId ? query?.joinWaitlistId : "join-waitlist-button"}
				>
					Join Waitlist
				</button>
			);
		} else if (totalAmount === 0) {
			return (
				<button
					className="btn cart-btn px-3 d-block btn-height no-box-shadow w-100 mx-auto my-3 mt-md-0"
					onClick={freeRegistration}
					disabled={btnDisabled}
					id={query?.registerButtonId ? query?.registerButtonId : "register-button"}
				>
					Register
				</button>
			);
		} else {
			return (
				<PaymentButton
					eventDetails={eventDetails}
					orderAmount={totalAmount}
					attendeesDetails={attendeesDetails}
					utm={utm}
					reviewDetails={reviewDetails}
					query={query}
					btnDisabled={btnDisabled}
					isWidget={isWidget}
					couponCode={couponCode}
					setApiLoading={setApiLoading}
					amountBreakUp={amountBreakUp}
					poweredByKhLogo={poweredByKhLogo}
					discount={discount}
					selectedTickets={selectedTickets}
					donationAmount={
						selectedTickets.find(
							(ticket) => ticket.ticket_type === 3 && ticket.donation_price,
						)?.donation_price || null
					}
					waitlistDetails={waitlistDetails}
				/>
			);
		}
	};

	const checkoutButtonType = (curComp, isCheckoutLoading) => {
		switch (curComp) {
			case 0:
				return "Proceed";
			case 1:
				if (isCheckoutLoading) {
					return <div className="spinner-border small-spinner ms-2"></div>;
				} else return restrictedEventId ? "Register" : "Checkout";
			case 3:
				return "Proceed";
		}
	};

	const amountBreakUp = orderAmountPreview && (
		<div className="flex-fill order-amount-sticker align-self-center">
			Total: <CurrencyWithAmount
				fontSize="16px"
				currencyName={currency}
				number={`${formatCurrencyAmount(parseFloat(orderAmountPreview), currency)}${typeof orderAmountPreview === "string" && orderAmountPreview?.includes("*") ? "*" : ""}`}
			/>
			<p className="mb-0 summary-text" onClick={toggleTicketSummary}>
				View Summary
			</p>
		</div>
	);

	const poweredByKhLogo = isWidget && (
		<div className="mobile-sticky mb-3">
			<hr className="d-md-none m-0 mb-3 powered-by-line" />

			{eventDetails?.checkout_footer_icon && (
				<a
					href={baseUrl}
					target="_blank"
					className="d-block d-md-none text-center"
				>
					<img
						src={eventDetails.checkout_footer_icon}
						className="image-container"
					/>
				</a>
			)}
		</div>
	);

	return (
		<div>
			<div className="cart-btns mt-2">
				{curComp !== 2 ? (
					<>
						{smallerScreen && orderAmount !== 0 ? (
							<div>
								<div className="d-flex px-3">
									{amountBreakUp}
									<TippyIcon
										content={
											curComp === 1 &&
												orderAmount > 0 &&
												isInternationalEvent &&
												!eventDetails.allowed_payment_methods?.length
												? `Registration for paid tickets will be available once the payment method is set up by the organizer`
												: isValidating ? "Validating email or phone number, please wait"
													: ""
										}
									>
										<div>
											<button
												className="btn cart-btn d-block btn-height mx-auto my-3 mt-md-0 pr-sm-2 xxx"
												disabled={
													_.isEmpty(selectedTickets) || isValidating ||
													(curComp === 1 &&
														(emailApiErrors.isError == true ||
															textInputErrors == true)) ||
													(curComp === 1 &&
														orderAmount > 0 &&
														isInternationalEvent &&
														!eventDetails.allowed_payment_methods?.length)
												}
												type="button"
												onClick={() => {
													curComp === 0
														? onProceed(selectedTickets)
														: setIsCheckoutSubmitted(true);
												}}
												id={checkoutButtonType(curComp, isCheckoutLoading) === "Checkout" ? query?.checkoutButtonId || "checkout-button" : query?.proceedButtonId || "proceed-button"}
											>
												{checkoutButtonType(curComp, isCheckoutLoading)}
											</button>
										</div>
									</TippyIcon>
								</div>

								{/*poweredByKhLogo*/}
							</div>
						) : (
							<TippyIcon
								content={
									curComp === 1 &&
										orderAmount > 0 &&
										isInternationalEvent &&
										!eventDetails.allowed_payment_methods?.length
										? "Registration for paid tickets will be available once the payment method is set up by the organizer"
										: isValidating ? "Validating email or phone number, please wait"
											: ""
								}
							>
								<div>
									<button
										className="btn cart-btn d-block btn-height my-3 mt-md-0 w-100 mx-auto"
										disabled={
											_.isEmpty(selectedTickets) || isValidating ||
											(curComp === 1 &&
												(emailApiErrors.isError == true ||
													textInputErrors == true)) ||
											(curComp === 1 &&
												orderAmount > 0 &&
												isInternationalEvent &&
												!eventDetails.allowed_payment_methods?.length)
										}
										type="button"
										onClick={() => {
											curComp === 0
												? onProceed(selectedTickets)
												: setIsCheckoutSubmitted(true);
										}}
										id={checkoutButtonType(curComp, isCheckoutLoading) === "Checkout" ? query?.checkoutButtonId || "checkout-button" : query?.proceedButtonId || "proceed-button"}
									>
										{checkoutButtonType(curComp, isCheckoutLoading)}
									</button>
									{/*poweredByKhLogo*/}
								</div>
							</TippyIcon>
						)}
					</>
				) : curComp === 2 ? (
					<>
						<div>
							<div
								className={
									smallerScreen && orderAmount !== 0 ? `d-flex px-4 cart-contain` : "w-100"
								}
							>
								{smallerScreen && orderAmount !== 0 && amountBreakUp}
								{registerButtonType(orderAmount)}
							</div>
						</div>
					</>
				) : null}
			</div>
			{curComp === 2 && eventDetails?.checkout_consent && (
				<p className="mt-3 cart-btns-term">
					{React.createElement("div", {
						dangerouslySetInnerHTML: {
							__html: stripHtmlTags(
								eventDetails.checkout_consent?.replace(/(?:\r\n|\r|\n)/g, "") ||
								"",
							),
						},
					})}
				</p>
			)}

			<style>
				{`
.image-container{
height: 85px;
width: auto;
}

.order-amount-sticker {
  font-size: 16px;
  font-weight: 500;
  margin-right: 15px;
}

.order-amount-sticker b {
  font-weight: 600;
}
.summary-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #000000;
  cursor: pointer;
}
.cart-btn {
    color: ${query.btnCl
						? `#${query.btnCl}`
						: query.btnBg
							? fontColorFunction("#" + query.btnBg)
							: "#ffffff"
					};
    background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
    height: 50px;
    width: ${!isWidget ? "100%" : "auto"};
    padding-left: ${!isWidget ? "30px" : "50px"};
    padding-right: ${!isWidget ? "30px" : "50px"};
    border: ${query.btnBg == "ffffff" ? "1px solid #000000 !important" : "none"};
  }

  .cart-btn:hover {
    color: ${query.btnCl
						? `#${query.btnCl}`
						: query.btnBg
							? fontColorFunction("#" + query.btnBg)
							: "#ffffff"
					} !important;
    // border: ${isWidget && query.btnBg == "ffffff" ? "1px solid #000000" : "none"}
    // background: ${query.btnBg == "ffffff" ? "#000000 !important" : `#${query.btnBg}`};
  }

  .cart-outline-btn {
    background: transparent;
    border-radius: 5px;
    font-size: 20px;
    font-weight: 500;
    padding: 10px 30px;
    transition: 0.2s all;
    color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
    border: 1px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
  }

  .cart-outline-btn:hover {
    color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
    background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
  }

  .cart-btns-term {
    font-size: 12px;
    word-break: break-word;
    color: ${query.secondaryCl ? `#${query.secondaryCl}` : "#572148"}
  }

  .cart-btns-term a {
    color: ${query.anchorTag ? `#${query.anchorTag}` : "#fb5850"} !important;
    text-decoration: none;
  }

  .w-90 {
    width: 90% !important;
  }
  @media (max-width: 768px) {
    .cart-btn{
        width:${orderAmount > 0 ? "auto !important" : "90% !important"};
        font-size: 16px !important;
    }

    .cart-btns-term {
      margin-top: 0px !important;
    }

    .cart-btns{
                width: 100vw;
                color: ${query.primaryCl ? `#${query.primaryCl}` : "#000000"};
                background: white;
                position: fixed;
                bottom: 0px;
                left: 0px;
                z-index: 100;
                box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.2);
                animation: ${selectedTickets.length > 0 ? "slideUp" : "slideDown"
					};
                0.3s forwards;
              	-webkit-animation: ${selectedTickets.length > 0 ? "slideUp" : "slideDown"}
                0.3s forwards; /* for less modern browsers */
            }
            // .pr-sm-2 {
            //   margin-right: 20px !important;
            // }
@media (max-width: 768px) {
  .cart-btn {
      font-size: 14px !important;
	  padding: 10px 25px !important;
  }
  .order-amount-sticker {
    font-size: 14px;
  }
  .summary-text {
    font-size: 12px !important;
  }
}
@media (max-width: 375px){
  .cart-btn {
    font-size: 14px !important;
    padding: 10px 15px !important;
	width:115px !important;
	
  }
  .cart-contain{
	padding-left: 0.5rem !important;
	padding-right: 0.5rem !important;
  }
  .order-amount-sticker{
	margin-right: 5px;
  }
}
`}
			</style>
		</div>
	);
};

export default CartButtons;